// src/pages/CreateEssens/CreateEssensScreen.js
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';

import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';
import Step5 from './Step5';

function CreateEssensScreen() {
  const navigate = useNavigate();
  const location = useLocation();

  const [step, setStep] = useState(1);
  const [checking, setChecking] = useState(true);
  const [userInput, setUserInput] = useState({
    kodeord: '',
    kjennetegn: '',
    essensSetning: '',
    tilkallingsformel: '',
    grensefilter: ''
  });

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        console.warn('⚠️ Ikke logget inn');
        setChecking(false);
        return;
      }

      const docRef = doc(db, 'kodeessens', user.uid);
      const docSnap = await getDoc(docRef);
      const data = docSnap.exists() ? docSnap.data() : null;

      console.log('Firestore-dokument:', data);

      // ✅ Forhåndsfyll hvis man kommer fra startskjermen
      if (location.state) {
        setUserInput({
          kodeord: location.state.kodeord || '',
          kjennetegn: location.state.kjennetegn || '',
          essensSetning: location.state.essensSetning || '',
          tilkallingsformel: location.state.tilkallingsformel || '',
          grensefilter: location.state.grensefilter || ''
        });
      }

      setChecking(false);
    });

    return () => unsubscribe();
  }, [navigate, location.state]);

  const goToSummary = () => {
    navigate('/summary', { state: userInput });
  };

  if (checking) {
    return (
      <div className="text-white text-center mt-12">
        <p>Sjekker brukerens Kode-Essens™ …</p>
      </div>
    );
  }

  return (
    <div className="p-6 bg-[#111] text-white min-h-screen">
      {step === 1 && (
        <Step1
          value={userInput.kodeord}
          onChange={(val) => setUserInput({ ...userInput, kodeord: val })}
          onNext={() => setStep(2)}
        />
      )}
      {step === 2 && (
        <Step2
          value={userInput.kjennetegn}
          onChange={(val) => setUserInput({ ...userInput, kjennetegn: val })}
          onNext={() => setStep(3)}
          onBack={() => setStep(1)}
        />
      )}
      {step === 3 && (
        <Step3
          value={userInput.essensSetning}
          onChange={(val) => setUserInput({ ...userInput, essensSetning: val })}
          onNext={() => setStep(4)}
          onBack={() => setStep(2)}
        />
      )}
      {step === 4 && (
        <Step4
          value={userInput.tilkallingsformel}
          onChange={(val) => setUserInput({ ...userInput, tilkallingsformel: val })}
          onNext={() => setStep(5)}
          onBack={() => setStep(3)}
        />
      )}
      {step === 5 && (
        <Step5
          value={userInput.grensefilter}
          onChange={(val) => setUserInput({ ...userInput, grensefilter: val })}
          onNext={goToSummary}
          onBack={() => setStep(4)}
        />
      )}
    </div>
  );
}

export default CreateEssensScreen;
